var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    { attrs: { viewBox: "0 0 72 72", xmlns: "http://www.w3.org/2000/svg" } },
    [
      _c("g", { attrs: { fill: "none", "fill-rule": "evenodd" } }, [
        _c("path", {
          attrs: {
            d:
              "M63.928 0H8.071C3.621 0 0 3.663 0 8.166v55.669C0 68.337 3.62 72 8.071 72h55.857C68.378 72 72 68.337 72 63.835V8.166C72 3.663 68.378 0 63.928 0",
            fill: "#D70177"
          }
        }),
        _c("path", {
          attrs: {
            d:
              "M49.5 45.75a1.339 1.339 0 01-1.33-1.339v-.178a3.3 3.3 0 00-.019-.348c.003-.05.008-.101.008-.152V31.896c0-.613-.043-1.215-.122-1.805 2.63 1.433 2.794 5.193 2.794 6.086V44.4c0 .744-.597 1.349-1.33 1.349zm-25.67-1.522V44.401c0 .744-.597 1.349-1.33 1.349a1.341 1.341 0 01-1.331-1.349v-8.224c0-.89.163-4.62 2.76-6.067a13.63 13.63 0 00-.12 1.792l.02 12.326zm14.383-18.5A12.853 12.853 0 0036 27.793a12.828 12.828 0 00-2.225-2.075 5.499 5.499 0 012.208-.468 5.482 5.482 0 012.23.477zM57 36.177c0-7.593-4.663-12.896-11.341-12.896-.205 0-.41.006-.612.015-1.953-2.305-4.674-3.866-7.733-4.22a11.518 11.518 0 00-6.372 1.083 12.312 12.312 0 00-4.019 3.136 13.777 13.777 0 00-.582-.014C19.663 23.28 15 28.584 15 36.177V44.4C15 48.591 18.364 52 22.5 52s7.5-3.41 7.5-7.61v-.179l-.022-12.315c0-.402.035-.796.097-1.179a6.67 6.67 0 012.825 5.46v12.698C32.9 50.6 34.28 52 35.984 52c1.704 0 3.084-1.399 3.084-3.125V36.598c.02-.14.033-.278.033-.421a6.67 6.67 0 012.796-5.44c.06.378.092.764.092 1.16v11.836c0 .114.007.226.02.338-.003.047-.008.093-.008.141v.189C42 48.591 45.364 52 49.5 52 53.634 52 57 48.59 57 44.401v-8.224z",
            fill: "#FFF"
          }
        })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }